//CRN_20260115 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { ExceptionsService } from './exceptions-service';
import { Injectable } from '@angular/core';
import tippy from "tippy.js";

@Injectable({ providedIn: 'root' })

export class TippyToolTipService {

  private tooltipInstance: any         | undefined;
  private tooltipTarget  : HTMLElement | undefined;

  constructor(
    private exceptionsService: ExceptionsService
  ) { }
  
  public chartTippyDestroy(): void {
    try {
      if (this.tooltipInstance) {
        this.tooltipInstance.destroy();
        this.tooltipInstance=undefined;
        this.tooltipTarget  =undefined;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public chartTippyHide(): void {
    try {
      if (this.tooltipInstance)
        this.tooltipInstance.hide();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public chartTippyShow(target: HTMLElement, html: string): void {
    try {
      if (!this.tooltipInstance || this.tooltipTarget !== target) {

        if (this.tooltipInstance)
          this.tooltipInstance.destroy();

        this.tooltipTarget=target;

        this.tooltipInstance=tippy(target, {
          allowHTML: true,
          theme    : 'ss-blue',
          placement: 'top',
          trigger  : 'manual',
        });
      }

      this.tooltipInstance.setContent(html);
      this.tooltipInstance.show();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public setupBootstrapTooltips(selector : string='[data-bs-toggle="tooltip"]',
                                placement: any='left'
                               ): void {
    try {
      tippy(selector, {
        allowHTML: true,
        placement: placement,
        theme    : 'ss-blue',
        onShow(instance) {
          const title=instance.reference.getAttribute('data-bs-title');
          
          if (title)
            instance.setContent(title);
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
